import { GenericException } from "./genericexception";
import { StatusCodes } from '../../core/util/statuscodes';

export class NoDataException extends GenericException
{
    constructor(errorDesc:string){
        super(errorDesc);
    }

    getStatusCode(){
        return String(StatusCodes.NO_CONTENT);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/exceptions/nodataexistsexception.tsx